(() => {
  if (window.RemediuSocialProofLoaded) return;

  window.RemediuSocialProofLoaded = true;

  const SELECTOR = '[data-rp-social-proof]';
  const instances = new WeakMap();

  class RemediuSocialProof {
    constructor(root, SwiperClass = window.Swiper) {
      this.root = root;
      this.SwiperClass = SwiperClass;
      this.swiper = null;
      this.blockCount = Number.parseInt(root.dataset.blockCount, 10) || 0;
      this.arrowsEnabled = root.dataset.arrowsEnabled !== 'false';
      this.handleResize = this.measureDescriptions.bind(this);
      window.addEventListener('resize', this.handleResize);
      this.init();
    }

    init() {
      this.measureDescriptions();

      const slider = this.root.querySelector('.rp-social-proof__swiper');

      if (!slider || !this.SwiperClass || this.blockCount < 2) return;

      const nextButton = this.root.querySelector('.rp-social-proof__button--next');
      const previousButton = this.root.querySelector('.rp-social-proof__button--prev');
      const hasDesktopOverflow = this.blockCount > 3 && this.arrowsEnabled;

      this.swiper = new this.SwiperClass(slider, {
        a11y: {
          enabled: true,
          nextSlideMessage: 'Testimonialul urmator',
          prevSlideMessage: 'Testimonialul anterior',
        },
        grabCursor: true,
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        loop: false,
        navigation: {
          enabled: false,
          nextEl: nextButton,
          prevEl: previousButton,
        },
        observer: true,
        observeParents: true,
        slidesPerView: 1.5,
        spaceBetween: 16,
        watchOverflow: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          990: {
            navigation: {
              enabled: hasDesktopOverflow,
            },
            slidesPerView: 3,
            spaceBetween: 24,
          },
        },
      });
    }

    measureDescriptions() {
      this.root.querySelectorAll('.rp-social-proof__description').forEach((description) => {
        description.style.setProperty(
          '--rp-social-proof-description-expanded-height',
          `${description.scrollHeight}px`,
        );
      });
    }

    selectBlock(block) {
      if (!this.swiper || !block) return;

      const slides = Array.from(this.root.querySelectorAll('.rp-social-proof__slide'));
      const index = slides.indexOf(block);

      if (index >= 0) this.swiper.slideTo(index);
    }

    destroy() {
      window.removeEventListener('resize', this.handleResize);

      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }

  const mount = (root) => {
    if (!root || instances.has(root)) return;

    instances.set(root, new RemediuSocialProof(root));
  };

  const unmount = (root) => {
    const instance = instances.get(root);

    if (!instance) return;

    instance.destroy();
    instances.delete(root);
  };

  const mountWithin = (container = document) => {
    if (container.matches?.(SELECTOR)) mount(container);
    container.querySelectorAll?.(SELECTOR).forEach(mount);
  };

  window.RemediuSocialProof = RemediuSocialProof;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => mountWithin());
  } else {
    mountWithin();
  }

  document.addEventListener('shopify:section:load', (event) => mountWithin(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    const root = event.target.matches?.(SELECTOR)
      ? event.target
      : event.target.querySelector?.(SELECTOR);

    unmount(root);
  });
  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target.closest?.('.rp-social-proof__slide');
    const root = block?.closest(SELECTOR);
    const instance = root ? instances.get(root) : null;

    instance?.selectBlock(block);
  });
})();
